const indexItems = [
  { label: '韩漫热门', icon: 'ri-kakao-talk-line', count: '328部', color: 'primary' },
  { label: '国漫精选', icon: 'ri-flag-2-line', count: '256部', color: 'accent' },
  { label: '日漫经典', icon: 'ri-sun-line', count: '412部', color: 'primary' },
  { label: '恋爱漫画', icon: 'ri-heart-line', count: '185部', color: 'accent' },
  { label: '奇幻冒险', icon: 'ri-rocket-line', count: '203部', color: 'primary' },
  { label: '逆袭爽文', icon: 'ri-flashlight-line', count: '167部', color: 'accent' },
  { label: '穿越题材', icon: 'ri-time-line', count: '142部', color: 'primary' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '98部', color: 'accent' },
  { label: '新作上架', icon: 'ri-sparkling-line', count: '56部', color: 'primary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              专题索引
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              按分类快速浏览布丁漫画下拉式阅读平台的全部漫画资源
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item, i) => {
              const colorClass = item.color === 'primary' 
                ? 'bg-primary-50 text-primary-600 border-primary-200/50 hover:border-primary-300 hover:bg-primary-100'
                : 'bg-accent-50 text-accent-600 border-accent-200/50 hover:border-accent-300 hover:bg-accent-100';
              const iconBgClass = item.color === 'primary'
                ? 'bg-primary-500 text-background-50'
                : 'bg-accent-500 text-background-50';
              
              return (
                <div
                  key={i}
                  className={`flex items-center gap-4 p-4 md:p-5 rounded-2xl border transition-all duration-200 cursor-pointer ${colorClass}`}
                >
                  <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${iconBgClass}`}>
                    <i className={`${item.icon} text-lg md:text-xl`}></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-sm font-heading font-bold truncate">{item.label}</div>
                    <div className="text-xs opacity-60 mt-0.5">{item.count}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}